// utils/search/createTransform.ts
import { useMemo } from "react";
import { getLabelNew, getLabel } from "./getLabel";

// Generic reusable  transform factory
export function useTransformLableNew(refinementKey: string) {
  return useMemo(() => {
    const labelCache = new Map<string, string>();
    const excludedLabels = ["under_review","removed","invited","lead", ""];

    return (items: any[]) => {
      return items      
      .filter((item: any) => refinementKey === "employerStatus" ? !excludedLabels.includes(item.label) : true)
      .map((item) => {
        const label = item.label;
        if (!labelCache.has(label)) {
          labelCache.set(label, getLabelNew(label, refinementKey));
        }

        return {
          ...item,
          label: labelCache.get(label),
        };
      });
    };
  }, [refinementKey]);
}

// Generic reusable  transform factory
export function useTransformLable(refinementKey: string) {
  return useMemo(() => {
    const labelCache = new Map<string, string>();

    return (items: any[]) => {
      return items.map((item) => {
        const label = item.label;
        if (!labelCache.has(label)) {
          labelCache.set(label, getLabel(label, refinementKey));
        }

        return {
          ...item,
          label: labelCache.get(label),
        };
      });
    };
  }, [refinementKey]);
}